import React from 'react';
import { Link } from 'react-router-dom';
import './Resume.css';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

const Resume = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('resume_authenticated');
    if (!isAuthenticated) {
      navigate('/ResumeLock');
    }
  }, [navigate]);

  const allSkills = [
    "JavaScript (ES6+)", "Java", "Python", "C++", "Go", "TypeScript", "SQL", "HTML5", "CSS3", "C", "R",
    "React", "Angular", "Vue.js", "Redux", "Next.js", "Tailwind CSS", "Bootstrap", "Material-UI", "Styled Components",
    "Node.js", "Express.js", "REST APIs", "GraphQL", "Spring Boot", "Microservices", "PostgreSQL", "MongoDB", "MySQL", "Redis", "DynamoDB",
    "AWS (EC2, S3, Lambda, RDS)", "Heroku", "ORACLE", "Google Cloud Platform", "Docker", "Kubernetes", "Jenkins", "GitHub Actions", "Git", "Jira", "Figma",
    "Jest", "Cypress", "Selenium", "Mocha", "Chai", "Power BI", "Tableau", "Google Analytics", "Agile/Scrum", "Test-Driven Development (TDD)", "CI/CD", "DevOps"
  ];

  const experiences = [
    {
        title: "Software Development Engineer – Full Stack",
        company: "Phoenix Tech Solutions",
        duration: "Jun 2018 - Feb 2020",
        description: "Implemented full stack applications using modern technologies, ensuring seamless integration between frontend and backend components using REST APIs and microservices architecture.",
        achievements: [
          "Implemented full stack applications using modern technologies, ensuring seamless integration between frontend and backend components using REST APIs and microservices architecture",
          "Developed pixel perfect React Front End web applications by collaborating with UX/UI designers to translate Figma wireframes into responsive components",
          "Developed and maintained scalable web applications using React, JavaScript, and Node.js, serving 50,000+ daily active users",
          "Owned features from design to deployment, including implementation, testing, and monitoring in production",
          "Collaborated with key stakeholders using Agile methodologies and lean practices to deliver impactful solutions"
        ]
      },
    {
      title: "Technical Product Manager",
      company: "Walmart",
      location: "Dallas, TX",
      duration: "Mar 2023 - Present",
      description: "Leading technical migration of legacy systems to modern React applications for international markets, coordinating with 15+ engineers across global teams.",
      achievements: [
        "Led technical migration of legacy systems to modern React applications for international markets, coordinating with 15+ engineers across global teams",
        "Developed roadmaps and cases to prioritize work against the roadmap, driving product feature planning and technical requirements definition",
        "Worked on scalable design solutions and long-term vision approaches for Walmart global platforms, supporting application availability for multiple business areas",
        "Collaborated cross-functionally with backend engineers, designers, and stakeholders using Agile/Scrum methodologies",
        "Improved back-end capabilities by managing integration of third-party applications to internal platforms, resulting in optimized operations and improved data insights"
      ]
    },
    {
      title: "Technical Product Manager",
      company: "Tesla",
      location: "Fremont, CA",
      duration: "Aug 2022 - Dec 2022",
      description: "Implemented Google Analytics 4 integration and custom event tracking for Tesla's service web applications, providing actionable insights into user behavior.",
      achievements: [
        "Implemented Google Analytics 4 integration and custom event tracking for Tesla's service web applications",
        "Collaborated with senior engineers to develop and test mobile-first responsive design features, ensuring cross-device compatibility",
        "Worked on frontend performance optimization initiatives including image optimization and caching strategies, improving Core Web Vitals scores by 25%",
        "Enhanced Tesla's service application through technical design sessions, improving scalability and reliability for millions of global customers"
      ]
    },
    {
      title: "Technical Product Manager",
      company: "Elevate",
      location: "Addison, TX",
      duration: "Jun 2022 - Aug 2022",
      description: "Led technical evaluation and implementation of Salesforce Lightning Web Components (LWC) for enterprise applications, improving page load times by 35%.",
      achievements: [
        "Led technical evaluation and implementation of Salesforce Lightning Web Components (LWC) for enterprise applications, improving page load times by 35%",
        "Managed end-to-end migration project from third-party software to custom in-house Salesforce solution, resulting in $75,000 annual cost savings",
        "Conducted system integration testing for enterprise applications, swiftly resolving critical issues to reduce downtime and enhance performance"
      ]
    },
    {
      title: "Salesforce Developer / Admin",
      company: "T-Digital",
      location: "Dallas, TX",
      duration: "Feb 2022 - May 2022",
      description: "Engineered large-scale data integration solutions connecting AT&T's Salesforce and AWS cloud infrastructure (150M+ records) via Heroku Postgres.",
      achievements: [
        "Engineered large-scale data integration solutions connecting AT&T's Salesforce and AWS cloud infrastructure (150M+ records) via Heroku Postgres using MuleSoft connectors and ETL pipelines",
        "Developed dynamic frontend data visualization components using Salesforce Lightning Web Components (LWC), supporting real-time data updates for 1000+ internal users",
        "Implemented comprehensive testing strategies including unit tests, integration tests, and User Acceptance Testing (UAT), identifying and resolving 10+ critical system issues",
        "Created technical documentation and conducted knowledge transfer sessions for development teams"
      ]
    },
    {
      title: "AI Robotic Associate",
      company: "Starship Technologies",
      location: "Richardson, TX",
      duration: "Aug 2021 - Jan 2022",
      description: "Improved the efficiency and reliability of autonomous AI delivery robots through feedback and collaborations with engineering, product, and operations teams.",
      achievements: [
        "Improved the efficiency and reliability of autonomous AI delivery robots through feedback and collaborations with engineering, product, and operations teams",
        "Monitored real-time robotic operations using proprietary analytic dashboards and alerting systems, ensuring 95%+ operational uptime",
        "Analyzed system and robotic fleet performance to improve machine learning model training and software optimization"
      ]
    },
    
  ];

  const education = [
    {
      degree: "Master of Science",
      field: "Information Technology and Management",
      institution: "University of Texas at Dallas",
      duration: "2021 - 2022",
      description: "Coursework: Software Engineering, Database Systems, Web Development, Data Analytics, Project Management, Product Management"
    },
    {
      degree: "Bachelor of Science",
      field: "Computer Science and Engineering",
      institution: "Sreyas Institute of Engineering and Technology",
      duration: "2014 - 2018",
      description: "Coursework: Data Structures, Algorithms, Object-Oriented Programming, Computer Networks, Database Management Systems, Object-Oriented System Design"
    }
  ];

  const certifications = [
    {
      name: "Project Management Professional (PMP)",
      issuer: "Project Management Institute",
      status: "Certified"
    },
    {
      name: "Certified Salesforce Administrator",
      issuer: "Salesforce",
      credentialId: "22730942",
      status: "Certified"
    },
    {
      name: "Google Ads Search Certification",
      issuer: "Google",
      credentialId: "119343692",
      status: "Certified"
    },
    {
      name: "AWS Cloud Practitioner",
      issuer: "Amazon Web Services",
      status: "In Progress"
    }
  ];

  const projects = [
    {
      name: "Dashboard Template",
      description: "Social media dashboard template built with vanilla CSS and JavaScript",
      tech: ["JavaScript", "TypeScript", "CSS", "HTML"],
      link: "https://darkferrari.github.io/dashboard/"
    },
    {
      name: "Ecommerce Website",
      description: "Full-stack ecommerce platform with React, Java, and Spring Boot",
      tech: ["React", "JavaScript", "MongoDB", "Java", "Spring Boot"],
      link: "#"
    },
    {
      name: "AI Chatbot",
      description: "AI chatbot application using Python and OpenAI API",
      tech: ["React", "Python", "OpenAI API", "MCP", "FastAPI"],
      link: "#"
    }
  ];

  return (
    <div className="resume-page">
      <div className="resume-container">
        {/* Header Section */}
        <header className="resume-header">
          <div className="header-content">
            <h1 className="resume-name">Neeraj Reddy</h1>
            <p className="resume-title">Full Stack Developer & Product Manager</p>
            <div className="contact-info">
              <p>📧 nxv200004@utdallas.edu</p>
              <p>🔗 <a href="https://github.com/DarkFerrari" target="_blank" rel="noopener noreferrer">GitHub</a></p>
              <p>💼 <a href="https://www.linkedin.com/in/neerajreddyv" target="_blank" rel="noopener noreferrer">LinkedIn</a></p>
              <p>🌐 BuiltVia.com/Neeraj</p>
            </div>
          </div>
          <div className="back-button">
            <Link to="/" className="btn-back">← Back to Portfolio</Link>
          </div>
        </header>

        {/* Summary Section */}
        <section className="resume-section">
          <h2 className="section-title">Professional Summary</h2>
          <p className="summary-text">
            Front-end focused Full-stack Software Development Engineer with expertise in creating high-performance web applications 
            using technologies like JavaScript/TypeScript, HTML5, CSS3, Java/Spring, C++, Python, Node.js and Object-Oriented Programming (OOPs) concepts. 
            Previously succeeded as a Product Manager, combining technical prowess with strategic insight to transform complex business requirements 
            into effective solutions. Demonstrated abilities include optimizing legacy software to new gen updates using frameworks like React, Vue.js, 
            or Angular, implementing organizational wide internal applications and analytics platforms, and advancing cloud technologies, particularly 
            within fintech and retail industries. Passion for UX consistency, accessibility, and empathetic design principles.
          </p>
        </section>

        

        {/* Experience Section */}
        <section className="resume-section">
          <h2 className="section-title">Professional Experience</h2>
          {experiences.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="experience-header">
                <h3 className="experience-title">{exp.title}</h3>
                <p className="experience-company">{exp.company}</p>
                {exp.location && <p className="experience-location">{exp.location}</p>}
                <p className="experience-duration">{exp.duration}</p>
              </div>
              <p className="experience-description">{exp.description}</p>
              <ul className="achievements-list">
                {exp.achievements.map((achievement, achIndex) => (
                  <li key={achIndex} className="achievement-item">{achievement}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>

        {/* Skills Section */}
        <section className="resume-section">
          <h2 className="section-title">Technical Skills</h2>
          <div className="skills-compact">
            {allSkills.map((skill, index) => (
              <span key={index} className="skill-tag">{skill}</span>
            ))}
          </div>
        </section>

        {/* Education Section */}
        <section className="resume-section">
          <h2 className="section-title">Education</h2>
          {education.map((edu, index) => (
            <div key={index} className="education-item">
              <h3 className="education-degree">{edu.degree} - {edu.field}</h3>
              <p className="education-institution">{edu.institution}</p>
              <p className="education-duration">{edu.duration}</p>
              <p className="education-description">{edu.description}</p>
            </div>
          ))}
        </section>

        {/* Certifications Section */}
        <section className="resume-section">
          <h2 className="section-title">Certifications</h2>
          <div className="certifications-grid">
            {certifications.map((cert, index) => (
              <div key={index} className="certification-item">
                <h3 className="certification-name">{cert.name}</h3>
                <p className="certification-issuer">{cert.issuer}</p>
                {cert.credentialId && (
                  <p className="certification-id">Credential ID: {cert.credentialId}</p>
                )}
                <span className={`certification-status ${cert.status.toLowerCase().replace(' ', '-')}`}>
                  {cert.status}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Projects Section */}
        <section className="resume-section">
          <h2 className="section-title">Notable Projects</h2>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-item">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">{tech}</span>
                  ))}
                </div>
                {project.link !== "#" && (
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                    View Project →
                  </a>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Footer */}
        <footer className="resume-footer">
          <p>© 2024 Neeraj Reddy. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Resume;
